import { render, staticRenderFns } from "./AncestrylineConfirmation.vue?vue&type=template&id=6b593274&scoped=true&"
import script from "./AncestrylineConfirmation.vue?vue&type=script&lang=js&"
export * from "./AncestrylineConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AncestrylineConfirmation.vue?vue&type=style&index=0&id=6b593274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b593274",
  null
  
)

export default component.exports